/* eslint-disable @typescript-eslint/no-inferrable-types */
/**
 * Specifies the chart constant value
 */
/** @private */
export const loaded = 'loaded';
/** @private */
export const legendClick = 'legendClick';
/** @private */
export const load = 'load';
/** @private */
export const animationComplete = 'animationComplete';
/** @private */
export const legendRender = 'legendRender';
/** @private */
export const textRender = 'textRender';
/** @private */
export const pointRender = 'pointRender';
/** @private */
export const sharedTooltipRender = 'sharedTooltipRender';
/** @private */
export const seriesRender = 'seriesRender';
/** @private */
export const axisLabelRender = 'axisLabelRender';
/** @private */
export const axisLabelClick = 'axisLabelClick';
/** @private */
export const axisRangeCalculated = 'axisRangeCalculated';
/** @private */
export const axisMultiLabelRender = 'axisMultiLabelRender';
/** @private */
export const tooltipRender = 'tooltipRender';
/** @private */
export const chartMouseMove = 'chartMouseMove';
/** @private */
export const chartMouseClick = 'chartMouseClick';
/** @private */
export const chartDoubleClick = 'chartDoubleClick';
/** @private */
export const pointClick = 'pointClick';
/** @private */
export const pointDoubleClick = 'pointDoubleClick';
/** @private */
export const pointMove = 'pointMove';
/** @private */
export const chartMouseLeave = 'chartMouseLeave';
/** @private */
export const chartMouseDown = 'chartMouseDown';
/** @private */
export const chartMouseUp = 'chartMouseUp';
/** @private */
export const zoomComplete = 'zoomComplete';
/** @private */
export const dragComplete = 'dragComplete';
/** @private */
export const selectionComplete = 'selectionComplete';
/** @private */
export const resized = 'resized';
/** @private */
export const beforeResize = 'beforeResize';
/** @private */
export const beforePrint = 'beforePrint';
/** @private */
export const annotationRender = 'annotationRender';
/** @private */
export const scrollStart = 'scrollStart';
/** @private */
export const scrollEnd = 'scrollEnd';
/** @private */
export const scrollChanged = 'scrollChanged';
/** @private */
export const stockEventRender = 'stockEventRender';
/** @private */
export const multiLevelLabelClick = 'multiLevelLabelClick';
/** @private */
export const dragStart = 'dragStart';
/** @private */
export const drag = 'drag';
/** @private */
export const dragEnd = 'dragEnd';
/*** @private*/
export const regSub = /~\d+~/g;
/*** @private*/
export const regSup = /\^\d+\^/g;
/** @private */
export const beforeExport = 'beforeExport';
/** @private */
export const afterExport = 'afterExport';
/** @private */
export const bulletChartMouseClick = 'bulletChartMouseClick';
/** @private */
export const onZooming = 'onZooming';
